<form
	[formGroup]="formGroup"
	class="au-forms count-range-filter"
	(click)="$event.stopPropagation()"
>
	<mat-form-field
		hideRequiredMarker
		class="au-search-input no-label"
		floatLabel="never"
		subscriptSizing="dynamic"
	>
		<input
			autocomplete="off"
			type="number"
			matInput
			[placeholder]="'from' | translate"
			auMatInputAutofocus
			formControlName="from"
		/>
	</mat-form-field>
	<span class="m-l-sxs m-r-sxs">—</span>
	<mat-form-field
		hideRequiredMarker
		class="au-search-input no-label"
		floatLabel="never"
		subscriptSizing="dynamic"
	>
		<input
			autocomplete="off"
			type="number"
			matInput
			[placeholder]="'to' | translate"
			formControlName="to"
		/>
	</mat-form-field>
</form>
